import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01531ead"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "about2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wenhao" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wenhaoTxt" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "txt1" }, "通过该患者的体格检查，以下"),
    /*#__PURE__*/_createElementVNode("div", { class: "txt1" }, "描述正确的有（多选）")
  ])
], -1))
const _hoisted_4 = { class: "zljg" }
const _hoisted_5 = { class: "huadong" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "wenti" }
const _hoisted_8 = { class: "radioBox" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "bottomBox" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ip" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, { show: true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_swipe, {
                autoplay: 3000,
                "lazy-render:true": "",
                "show-indicators:true": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (image) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, { key: image }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", { src: image }, null, 8, _hoisted_6)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_van_checkbox_group, {
                modelValue: $data.checkVal,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.checkVal) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_van_checkbox, {
                      key: "1",
                      value: "1",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "1"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_9)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("A.全身皮肤干燥脱屑 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_van_checkbox, {
                      key: "2",
                      value: "2",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "2"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_10)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("B.背部、腹部及四肢暗红色斑块、 丘疹 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_van_checkbox, {
                      key: "3",
                      value: "3",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "3"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_11)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("C.表面见黄色痂皮和白色鳞屑 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_van_checkbox, {
                      key: "4",
                      value: "4",
                      modelValue: $setup.checkedd,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.checkedd) = $event)),
                      name: "4"
                    }, {
                      icon: _withCtx((props) => [
                        _createElementVNode("img", {
                          class: "img-icon",
                          src: props.checked ? $data.activeIcon : $data.inactiveIcon
                        }, null, 8, _hoisted_12)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode("D.局部见抓痕、表皮剥脱、皲裂 及出血 ")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_image, {
            onClick: $options.tansuo,
            width: "4.528rem",
            height: "1.32rem",
            src: require('../assets/jiemi.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _hoisted_14,
    _hoisted_15,
    _createVNode(_component_toNav, { menu: 2 })
  ], 64))
}